import React, { Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useBetsStore from './stores/betsStore';
import useAuthStore from './stores/authStore';
import LoadingSpinner from './components/LoadingSpinner';
import BetSlipSheet from './components/BetSlipSheet';
import client from './api/client';

import { useWebSocket } from './hooks/useWebSocket';

const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const OddsPage = React.lazy(() => import('./pages/OddsPage'));
const BetSlipPage = React.lazy(() => import('./pages/BetSlipPage'));
const HistoryPage = React.lazy(() => import('./pages/HistoryPage'));
const ProfilePage = React.lazy(() => import('./pages/ProfilePage'));

function App() {
  useWebSocket();
  const { isOpen, clear } = useBetsStore();
  const { isAuthenticated, balance, updateBalance, setUser } = useAuthStore();

  // Session restore: when token exists but store has stale/zero balance, refetch
  useEffect(() => {
    if (!isAuthenticated) return;
    client.get('/wallet/balance')
      .then(({ data }) => { if (data?.balance !== undefined) updateBalance(data.balance); })
      .catch(() => {/* 401 handled by interceptor */});
  }, [isAuthenticated]);

  return (
    <div className="min-h-screen bg-[#121212] text-white font-sans">
      <Suspense fallback={<LoadingSpinner fullScreen />}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/odds" element={<OddsPage />} />
          <Route path="/betslip" element={<BetSlipPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Routes>
      </Suspense>
      <BetSlipSheet isOpen={isOpen} onClose={clear} />
      <Toaster
        position="top-center"
        toastOptions={{
          style: { background: '#1E1E1E', color: '#FFFFFF', border: '1px solid #333' }
        }}
      />
    </div>
  );
}

export default App;
